<i18n>
{
	"en": {
		"freightLines": "Freight lines | Freight lines ({n}) | Freight lines ({n})",
		"priceLines": "Price lines | Price lines ({n}) | Price lines ({n})",
		"freeText": "Free text | Free text ({n}) | Free text ({n})",
		"otherReferences": "Other references | Other references ({n}) | Other references ({n})",
		"systemReferences": "System references",
		"deviations": "Deviations | Deviations ({n}) | Deviations ({n})",
		"events": "Events | Events ({n}) | Events ({n})",
		"packageEvents": "Package Events | Package Events ({n}) | Package Events ({n})",
		"ediLog": "EDI log | EDI log ({n}) | EDI log ({n})",
		"packages": "Packages | Packages ({n}) | Packages ({n})",
		"documents": "Documents | Documents ({n}) | Documents ({n})"
	},
	"no": {
		"freightLines": "Fraktlinjer | Fraktlinjer ({n}) | Fraktlinjer ({n})",
		"priceLines": "Prislinjer | Prislinjer ({n}) | Prislinjer ({n})",
		"freeText": "Fritekst | Fritekst ({n}) | Fritekst ({n})",
		"otherReferences": "Andre referanser | Andre referanser ({n}) | Andre referanser ({n})",
		"systemReferences": "System referanser",
		"deviations": "Avvik | Avvik ({n}) | Avvik ({n})",
		"events": "Hendelser | Hendelser ({n}) | Hendelser ({n})",
		"packageEvents": "Kolli-hendelser | Kolli-hendelser ({n}) | Kolli-hendelser ({n})",
		"ediLog": "EDI logg | EDI logg ({n}) | EDI logg ({n})",
		"packages": "Kolli | Kolli ({n}) | Kolli ({n})",
		"documents": "Dokumenter | Dokumenter ({n}) | Dokumenter ({n})"
	}
}
</i18n>

<template>
	<div class="details-main">
		<div>
			<template v-for="tab in detailTabs">
				<t-tab
					:ref="tab.id"
					:key="tab.id"
					class="detail-tab"
					:value="tab.name"
					:selected="tab.id === currentTabId"
					disableTabbing
					@selected="$emit('setSelectedTab', tab.id)"
				>
					{{ tab.name }}
				</t-tab>
			</template>
		</div>
		<div class="container">
			<t-pane v-bind="paneOptions">
				<component
					:is="currentTab.component"
					:order="order"
					:selectedSubOrder="selectedSubOrder"
				/>
			</t-pane>
		</div>
	</div>
</template>

<script>

import FreightLines from '@/modules/newOrder/details/FreightLines';
import PriceLines from '@/modules/newOrder/details/PriceLines';
import FreeText from '@/modules/newOrder/details/FreeText';
import OtherReferences from '@/modules/newOrder/details/OtherReferences';
import SystemReferences from '@/modules/newOrder/details/SystemReferences';
import Deviations from '@/modules/newOrder/details/Deviations';
import Events from '@/modules/newOrder/details/Events';
import PackageEvents from '@/modules/newOrder/details/PackageEvents';
import EdiLog from '@/modules/newOrder/details/EdiLog';
import { mapState } from '@/modules/newOrder/store/newOrder.store';
import FreeTextSubOrder from '@/modules/newOrder/details/FreeTextSubOrder';
import Documents from '@/modules/newOrder/details/Documents';
import Packages from '@/modules/newOrder/details/Packages';
import TPane from '@/components/evergreen/layers/TPane';
import TTab from '@/components/evergreen/tabs/TTab';

export default {
	name: 'DetailsMain',
	components: { TTab, TPane },
	props: {
		currentTabId: {
			type: String,
			required: true
		},
		isSubOrder: {
			type: Boolean,
			required: false
		},
	},
	data() {
		return {
			paneOptions: {
				height: '100%',
				border: 'default',
				background: 'tint2',
				borderRadius: '5px',
				style: { overflow: 'hidden', }
			},
		};
	},
	computed: {
		...mapState(['order', 'selectedSubOrder', 'ediLog']),
		currentTab() {
			return this.detailTabs.find(
				tab => tab.id === this.currentTabId
			);
		},

		counts() {

			let { deviationBindings } = this.order;
			let counts = {
				freightLines:	this.order.freightLines		&& this.order.freightLines.length	? this.order.freightLines.length : 0,
				priceLines:		this.order.priceLines		&& this.order.priceLines.length		? this.order.priceLines.length : 0,
				deviations:		deviationBindings			&& deviationBindings.length			? deviationBindings.length : 0,
				events:			this.order.events			&& this.order.events.length			? this.order.events.length : 0,
				packageEvents:	this.order.packageEvents	&& this.order.packageEvents.length	? this.order.packageEvents.length : 0,
				ediLog:			this.ediLog					&& this.ediLog.length				? this.ediLog.length : 0,
				documents:		this.order.documents		&& this.order.documents.length		? this.order.documents.length : 0,
			};

			counts.freeText = 0;
			if (this.isSubOrder) {

				if (this.selectedSubOrder && this.selectedSubOrder.transporterInstructions && this.selectedSubOrder.transporterInstructions.length)
					counts.freeText += 1;
				if (this.selectedSubOrder && this.selectedSubOrder.invoiceFreeText && this.selectedSubOrder.invoiceFreeText.length)
					counts.freeText += 1;
				if (this.selectedSubOrder && this.selectedSubOrder.loadingListFreeText && this.selectedSubOrder.loadingListFreeText.length)
					counts.freeText += 1;
				if (this.selectedSubOrder && this.selectedSubOrder.internalNotes && this.selectedSubOrder.internalNotes.length)
					counts.freeText += 1;
				if (this.selectedSubOrder && this.selectedSubOrder.goodsListFreeText && this.selectedSubOrder.goodsListFreeText.length)
					counts.freeText += 1;

			} else {

				if (this.order.transporterInstructions && this.order.transporterInstructions.length)
					counts.freeText += 1;
				if (this.order.invoiceFreeText && this.order.invoiceFreeText.length)
					counts.freeText += 1;
				if (this.order.loadingListFreeText && this.order.loadingListFreeText.length)
					counts.freeText += 1;
				if (this.order.internalNotes && this.order.internalNotes.length)
					counts.freeText += 1;
				if (this.order.goodsListFreeText && this.order.goodsListFreeText.length)
					counts.freeText += 1;
			}

			counts.otherReferences = 0;
			if (this.order.additionalReferences)
				this.order.additionalReferences.forEach(
					reference => {
						if (reference.value && reference.value.length)
							counts.otherReferences += 1;
					}
				);

			// TODO: add counts for systemReferences

			return counts;
		},

		packagesCount() {
			let count = 0;

			this.order.freightLines && this.order.freightLines.forEach(
				freightLine => count += freightLine.numberOfUnits
			);

			return count;
		},

		detailTabs() {
			return [
				{
					id: 'freightLines',
					name: this.$tc('freightLines', this.counts.freightLines),
					component: FreightLines
				},
				{
					id: 'priceLines',
					name: this.$tc('priceLines', this.counts.priceLines),
					component: PriceLines
				},
				{
					id: 'freeText',
					name: this.$tc('freeText', this.counts.freeText),
					component: this.isSubOrder ? FreeTextSubOrder : FreeText
				},
				{
					id: 'otherReferences',
					name: this.$tc('otherReferences', this.counts.otherReferences),
					component: OtherReferences
				},
				{
					id: 'systemReferences',
					name: this.$t('systemReferences'),
					component: SystemReferences
				},
				{
					id: 'deviations',
					name: this.$tc('deviations', this.counts.deviations),
					component: Deviations
				},
				{
					id: 'events',
					name: this.$tc('events', this.counts.events),
					component: Events
				},
				{
					id: 'packageEvents',
					name: this.$tc('packageEvents', this.counts.packageEvents),
					component: PackageEvents
				},
				{
					id: 'ediLog',
					name: this.$tc('ediLog', this.counts.ediLog),
					component: EdiLog
				},
				{
					id: 'packages',
					name: this.$tc('packages',  this.packagesCount),
					component: Packages
				},
				{
					id: 'documents',
					name: this.$tc('documents',  this.counts.documents),
					component: Documents
				},
			];
		}
	},
	watch: {
		currentTabId(tabId) {
			this.$refs[tabId][0].$el.focus();
		}
	},
	mounted() {
		this.$emit(
			'mounted',
			{ detailTabIds: this.detailTabs.map( tab => tab.id ) });
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.details-main {
	height:100%;
	display: flex;
	flex-direction: column;
}
.container {
	flex:1;
	margin-top: 4px;
	grid-column: 1/5;
	min-height: 160px;
}

</style>